import { useState } from "react";
import axiosInstance from "../../api/axiosInstance";
 
export default function SupplyNumberInput({ onChange, onClear, onFetched, error }) {
 
  const [supplyInput, setSupplyInput] = useState("");   // single input before Get
  const [showGrid,    setShowGrid]    = useState(false); // toggle grid after Get
 
  // TOP ROW — 3 boxes (2 + 4 + 3 = 9 digits)
  const [top, setTop] = useState({ a: "", b: "", c: "" });
 
  // BOTTOM ROW — 4 boxes (2 + 4 + 4 + 3 = 13 digits)
  const [bot, setBot] = useState({ a: "", b: "", c: "", d: "" });
 
  const [loading,    setLoading]    = useState(false);
  const [fetchError, setFetchError] = useState("");
  const [isFetched,  setIsFetched]  = useState(false);
  const [isNotFound, setIsNotFound] = useState(false);
  const [dupError,   setDupError]   = useState("");
 
  // ── Refs for auto-focus ─────────────────────────────────
  const topBRef = { current: null };
  const topCRef = { current: null };
  const botARef = { current: null };
  const botBRef = { current: null };
  const botCRef = { current: null };
  const botDRef = { current: null };
 
  // ── Check MPAN duplicate ────────────────────────────────
  const checkDuplicate = async (mpan) => {
    try {
      const res = await axiosInstance.get(`/leads/check-mpan-core/${encodeURIComponent(mpan)}`);
      if (res.data.exists) {
        setDupError("⚠ This MPAN already exists");
      } else {
        setDupError("");
      }
    } catch (err) {
      console.error(err);
    }
  };
 
  // ── Handle top row input ────────────────────────────────
  const handleTop = (field, maxLen, nextRef) => (e) => {
    const val = e.target.value.replace(/[^a-zA-Z0-9]/g, "").slice(0, maxLen);
    const updated = { ...top, [field]: val };
    setTop(updated);
 
    const full = `${updated.a}${updated.b}${updated.c}`;
    onChange({ target: { name: "elecSupplyNumber", value: full } });
 
    if (val.length === maxLen && nextRef?.current) nextRef.current.focus();
  };
 
  // ── Handle bottom row input ─────────────────────────────
//   const handleBot = (field, maxLen, nextRef) => (e) => {
//     const val = e.target.value.replace(/\D/g, "").slice(0, maxLen);
//     const updated = { ...bot, [field]: val };
//     setBot(updated);
// if (val.length === maxLen && nextRef?.current) nextRef.current.focus();
//     const full = `${updated.a}${updated.b}${updated.c}${updated.d}`;
 
//     if (full.length === 13) {
//       checkDuplicate(full);
//       if (onFetched) onFetched({ mpan_core: full });
//     } else {
//       setDupError("");
//     }
 
//     if (val.length === maxLen && nextRef?.current) nextRef.current.focus();
//   };
 
 
 
const handleBot = (field, maxLen, nextRef) => (e) => {
  const val = e.target.value.replace(/\D/g, "").slice(0, maxLen);
  const updated = { ...bot, [field]: val };
  setBot(updated);
 
  const full = `${updated.a}${updated.b}${updated.c}${updated.d}`;
 
  // ✅ always sync to parent, even when partial or empty
  if (onFetched) onFetched({ mpan_core: full });
 
  if (full.length === 13) {
    checkDuplicate(full);
  } else {
    setDupError("");
  }
 
  if (val.length === maxLen && nextRef?.current) nextRef.current.focus();
};
  // ── GET button ──────────────────────────────────────────
  const handleGet = async () => {
  if (!supplyInput.trim()) {
    setFetchError("Enter a supply number first");
    return;
  }
 
  try {
    setLoading(true);
    setFetchError("");
    setIsNotFound(false);
    setDupError("");
 
    const res = await axiosInstance.get(`/mpan/${encodeURIComponent(supplyInput.trim())}`);
 
    if (res.data.success) {
      const data = res.data.data;
      setIsFetched(true);
      setShowGrid(true);
 
      const raw = supplyInput.replace(/\D/g, "");
      setTop({
        a: raw.slice(0, 2),
        b: raw.slice(2, 6),
        c: raw.slice(6, 9),
      });
 
      // ✅ Tell parent the supply number value
      onChange({ target: { name: "elecSupplyNumber", value: raw } });
 
      if (data.mpan_core) {
        const core = data.mpan_core.replace(/\D/g, "");
        setBot({
          a: core.slice(0, 2),
          b: core.slice(2, 6),
          c: core.slice(6, 10),
          d: core.slice(10, 13),
        });
        checkDuplicate(core);
        if (onFetched) onFetched({ mpan_core: data.mpan_core });
      }
    }
  } catch (err) {
    if (err?.response?.status === 404) {
      setIsNotFound(true);
      setIsFetched(false);
      setShowGrid(true);
 
      const raw = supplyInput.replace(/\D/g, "");
      setTop({
        a: raw.slice(0, 2),
        b: raw.slice(2, 6),
        c: raw.slice(6, 9),
      });
      setBot({ a: "", b: "", c: "", d: "" });
if (onFetched) onFetched({ mpan_core: "" });      // ← add
      // ✅ Tell parent even when not found
      onChange({ target: { name: "elecSupplyNumber", value: raw } });
 
      setFetchError("");
    } else {
      setFetchError(err?.response?.data?.message || "Something went wrong");
      setShowGrid(false);
    }
  } finally {
    setLoading(false);
  }
};
 
  // ── CLEAR ───────────────────────────────────────────────
  const handleClear = () => {
    setSupplyInput("");
    setShowGrid(false);
    setTop({ a: "", b: "", c: "" });
    setBot({ a: "", b: "", c: "", d: "" });
    setIsFetched(false);
    setIsNotFound(false);
    setFetchError("");
    setDupError("");
    onClear();
  };
 
  // ── Box style ───────────────────────────────────────────
  const boxCls = (len, filled) => `
    border-0 text-center text-sm font-mono text-gray-900
    focus:outline-none focus:ring-1 focus:ring-blue-500
    py-1.5
    ${len === 2 ? "w-10" : len === 3 ? "w-12" : "w-16"}
    ${filled ? "bg-blue-50" : "bg-white"}
  `;
 
  return (
    <div className="flex-1">
 
      {/* ── STEP 1: Single input + buttons ──────────────── */}
      {!showGrid && (
        <div className="flex items-stretch gap-2">
 
          {/* GET BUTTON */}
        {/* GET BUTTON */}
<button
  type="button"
  onClick={handleGet}
  disabled={loading || supplyInput.replace(/\D/g, "").length !== 9}
  className="px-4 py-2 text-xs font-semibold border border-gray-400 bg-blue-600 text-white disabled:opacity-40 disabled:cursor-not-allowed shrink-0"
>
  {loading ? "..." : "Get"}
</button>
 
          {/* CLEAR BUTTON */}
          <button
            type="button"
            onClick={handleClear}
            className="px-4 py-2 text-xs font-semibold border border-gray-400 bg-pink-200 text-gray-700 shrink-0"
          >
            Clear
          </button>
 
          {/* SUPPLY NUMBER INPUT */}
          <input
            type="text"
            value={supplyInput}
             maxLength={9}
           onChange={(e) => {
  const val = e.target.value.replace(/\D/g, "").slice(0, 9); // ← digits only
  setSupplyInput(val);
  setFetchError("");
}}
 
            onKeyDown={(e) => e.key === "Enter" && handleGet()}
            placeholder="Enter supply number"
            className={`
              flex-1 border px-3 py-2 text-sm text-gray-900 bg-white
              focus:outline-none focus:ring-1
              ${error || fetchError
                ? "border-red-500 focus:ring-red-400"
                : "border-gray-400 focus:ring-blue-500"
              }
            `}
          />
        </div>
      )}
 
      {/* ── STEP 2: MPAN Grid (after Get) ───────────────── */}
      {showGrid && (
        <>
          <div className="flex items-center gap-2 mb-2">
            <button
              type="button"
              onClick={handleClear}
              className="px-4 py-1.5 text-xs font-semibold border border-gray-400 bg-pink-200 text-gray-700"
            >
              Clear
            </button>
            <span className="text-xs text-gray-500 italic">
              Supply: <strong>{supplyInput}</strong>
            </span>
          </div>
 
          {/* MPAN BOX */}
          <div className="inline-flex items-stretch border border-gray-400 bg-white">
 
            {/* S PREFIX */}
            <div className="flex items-center justify-center bg-gray-100 border-r border-gray-400 px-3">
              <span className="text-[22px] font-black text-indigo-700 leading-none">S</span>
            </div>
 
            {/* TWO ROWS */}
            <div className="flex flex-col divide-y divide-gray-300">
 
              {/* TOP ROW — 2 + 4 + 3 = 9 digits */}
              <div className="flex items-center divide-x divide-gray-300">
                <input
                  maxLength={2}
                  value={top.a}
                  onChange={handleTop("a", 2, topBRef)}
                  ref={(el) => { topBRef.current = el; }}
                  placeholder="04"
                  className={boxCls(2, top.a.length === 2)}
                />
                <input
                  maxLength={4}
                  value={top.b}
                  onChange={handleTop("b", 4, topCRef)}
                  ref={(el) => { topCRef.current = el; }}
                  placeholder="0151"
                  className={boxCls(4, top.b.length === 4)}
                />
                <input
                  maxLength={3}
                  value={top.c}
                  onChange={handleTop("c", 3, botARef)}
                  ref={(el) => { botARef.current = el; }}
                  placeholder="201"
                  className={boxCls(3, top.c.length === 3)}
                />
              </div>
 
              {/* BOTTOM ROW — 2 + 4 + 4 + 3 = 13 digits */}
              <div className="flex items-center divide-x divide-gray-300">
                <input
                  maxLength={2}
                  value={bot.a}
                  onChange={handleBot("a", 2, botBRef)}
                  ref={(el) => { botBRef.current = el; }}
                  placeholder="10"
                  className={boxCls(2, bot.a.length === 2)}
                />
                <input
                  maxLength={4}
                  value={bot.b}
                  onChange={handleBot("b", 4, botCRef)}
                  ref={(el) => { botCRef.current = el; }}
                  placeholder="1246"
                  className={boxCls(4, bot.b.length === 4)}
                />
                <input
                  maxLength={4}
                  value={bot.c}
                  onChange={handleBot("c", 4, botDRef)}
                  ref={(el) => { botDRef.current = el; }}
                  placeholder="5223"
                  className={boxCls(4, bot.c.length === 4)}
                />
                <input
                  maxLength={3}
                  value={bot.d}
                  onChange={handleBot("d", 3, null)}
                  placeholder="981"
                  className={boxCls(3, bot.d.length === 3)}
                />
              </div>
 
            </div>
          </div>
        </>
      )}
 
      {/* ── STATUS MESSAGES ─────────────────────────────── */}
      {loading && (
        <p className="text-xs text-gray-400 italic mt-1">Fetching MPAN...</p>
      )}
 
      {isFetched && !dupError && (
        <p className="text-green-600 text-[11px] mt-1 font-medium">✅ MPAN found and filled</p>
      )}
 
      {isNotFound && (
        <p className="text-amber-600 text-[11px] mt-1 font-medium">
          ⚠ MPAN number not found. Please fill bottom row manually.
        </p>
      )}
 
      {dupError && (
        <p className="text-red-500 text-[11px] mt-1 font-semibold">{dupError}</p>
      )}
 
      {(fetchError || error) && (
        <p className="text-red-500 text-[11px] mt-1">{fetchError || error}</p>
      )}
 
    </div>
  );
}
 
